import { Bell, Menu, Search } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { Avatar } from './UI';

export default function Topbar({ onMenuToggle, title }) {
  const { user } = useAuth();
  const today = new Date().toLocaleDateString('en-IN', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <div className="topbar">
      <div className="topbar-left">
        <button className="btn btn-ghost btn-icon" onClick={onMenuToggle} style={{ display: 'none' }} id="menu-toggle">
          <Menu size={20} />
        </button>
        <div>
          <div style={{ fontWeight: 700, fontSize: '1rem' }}>{title || 'Dashboard'}</div>
          <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>{today}</div>
        </div>
      </div>
      <div className="topbar-right">
        <button className="btn btn-ghost btn-icon" style={{ position: 'relative' }}>
          <Bell size={18} />
          <span style={{ position: 'absolute', top: 6, right: 6, width: 7, height: 7, background: 'var(--danger)', borderRadius: '50%', border: '1.5px solid white' }} />
        </button>
        <div style={{ display: 'flex', alignItems: 'center', gap: 9, padding: '6px 12px', background: 'var(--surface-alt)', borderRadius: 'var(--r-sm)', border: '1px solid var(--border)' }}>
          <Avatar name={user?.full_name} src={user?.photo_url} />
          <div>
            <div style={{ fontSize: '0.82rem', fontWeight: 700 }}>{user?.full_name}</div>
            <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)', textTransform: 'capitalize' }}>{user?.role}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
